<template>
    <div class="app-container">
        <el-form :model="queryParams" style="text-align: left" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
            <el-form-item label="用户名称" prop="userName">
                <el-input
                        v-model="queryParams.userName"
                        placeholder="请输入用户名称"
                        clearable
                        style="width: 240px"
                        @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item label="手机号码" prop="userPhone">
                <el-input
                        v-model="queryParams.userPhone"
                        placeholder="请输入手机号码"
                        clearable
                        style="width: 240px"
                        @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-select
                        v-model="queryParams.status"
                        placeholder="用户状态"
                        clearable
                        style="width: 240px"
                >
                    <el-option label="启用" value="0"/>
                    <el-option label="停用" value="1"/>
                </el-select>
            </el-form-item>
            <el-form-item label="创建时间">
                <el-date-picker
                        v-model="dateRange"
                        style="width: 240px"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                ></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>

        <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">
                <el-button
                        type="primary"
                        plain
                        icon="el-icon-plus"
                        size="mini"
                        @click="handleAdd"

                >新增</el-button>
            </el-col>
            <el-col :span="1.5">
                <el-button
                        type="danger"
                        plain
                        icon="el-icon-delete"
                        size="mini"
                        :disabled="multiple"
                        @click="handleDelete"
                >删除</el-button>
            </el-col>
<!--            <el-col :span="1.5">-->
<!--                <el-button-->
<!--                        type="info"-->
<!--                        plain-->
<!--                        icon="el-icon-upload2"-->
<!--                        size="mini"-->
<!--                        @click="handleImport"-->
<!--                >导入</el-button>-->
<!--            </el-col>-->
            <el-col :span="1.5">
                <el-button
                        type="warning"
                        plain
                        icon="el-icon-download"
                        size="mini"
                        @click="handleExport"
                >导出</el-button>
            </el-col>
        </el-row>

        <el-table row-key="userId" v-loading="loading" :data="userList" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="50" align="center" :reserve-selection="true" />
            <el-table-column width="50" label="人员编号" align="center" prop="id" />
            <el-table-column label="用户名称" align="center" prop="userName" :show-overflow-tooltip="true" />
            <el-table-column label="手机号码" align="center" prop="userPhone" width="120" />
            <el-table-column label="邮箱" align="center" prop="email"/>
            <el-table-column label="角色称呼" align="center" prop="roleName" />
            <el-table-column label="所属学校" align="center" prop="schoolName" min-width="140" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span>{{ scope.row.schoolName || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="状态" align="center" key="status">
                <template slot-scope="scope">
                    <el-switch
                            v-model="scope.row.status"
                            active-value="0"
                            inactive-value="1"
                            @change="handleStatusChange(scope.row)"
                            :disabled="scope.row.roleKey=='admin'"
                    ></el-switch>
                </template>
            </el-table-column>
            <el-table-column  label="创建时间" align="center" prop="createTime" width="200">
                <template slot-scope="scope">
                    <span>{{ scope.row.createTime | dateFormat }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="操作"
                    align="center"
                    width="160"
                    class-name="small-padding fixed-width"
            >
                <template slot-scope="scope" v-if="scope.row.userId !== 1">
                    <el-button
                            size="mini"
                            type="text"
                            icon="el-icon-edit"
                            @click="handleUpdate(scope.row)"
                    >修改</el-button>
                    <el-button
                            size="mini"
                            type="text"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.row)"
                    >删除</el-button>
                    <el-dropdown size="mini" @command="(command) => handleCommand(command, scope.row)">
                        <el-button size="mini" type="text" icon="el-icon-d-arrow-right">更多</el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="handleResetPwd" icon="el-icon-key">重置密码</el-dropdown-item>
                            <!--                                    <el-dropdown-item command="handleAuthRole" icon="el-icon-circle-check">分配角色</el-dropdown-item>-->
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>

        <template v-if="userList.length!=0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.pageNum" :page-sizes="[1, 2, 5, 10]"
                           :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </template>

        <!-- 添加或修改用户配置对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="用户名称" prop="userName">
                            <el-input v-model="form.userName" placeholder="请输入用户名称" maxlength="30" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="用户密码" prop="password">
                            <el-input v-model="form.password" placeholder="请输入用户密码" type="password" maxlength="20" show-password/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="手机号码" prop="userPhone">
                            <el-input v-model="form.userPhone" placeholder="请输入手机号码" maxlength="11" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="邮箱" prop="email">
                            <el-input v-model="form.email" placeholder="请输入邮箱" maxlength="50" />
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="用户性别">
                            <el-select v-model="form.sex" placeholder="请选择性别">
                                <el-option
                                        v-for="sex in sexList"
                                        :key="sex.value"
                                        :label="sex.label"
                                        :value="sex.value"
                                        :disabled="sex.status == 1"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="状态">
                            <el-radio-group v-model="form.status" :disabled="form.roleKey=='admin'">
                                <el-radio key="0" label="0">启用</el-radio>
                                <el-radio key="1" label="1">停用</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="角色">
                            <el-select v-model="form.roleId" placeholder="请选择角色" @change="onRoleChange">
                                <el-option
                                        v-for="role in roleOptions"
                                        :key="role.id"
                                        :label="role.roleName"
                                        :value="role.id"
                                        :disabled="role.status == 1"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="isCampusAgentForm">
                        <el-form-item label="所属学校" prop="schoolId" :rules="[{ required: true, message: '校园代理必须绑定学校', trigger: 'change' }]">
                            <el-select v-model="form.schoolId" filterable placeholder="请选择学校">
                                <el-option
                                        v-for="school in schoolList"
                                        :key="school.schoolId"
                                        :label="school.schoolName"
                                        :value="school.schoolId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="备注">
                            <el-input v-model="form.remark" type="textarea" placeholder="请输入内容"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>

        <!-- 用户导入对话框 -->
<!--        <el-dialog :title="upload.title" :visible.sync="upload.open" width="400px" append-to-body>-->
<!--            <el-upload-->
<!--                    ref="upload"-->
<!--                    :limit="1"-->
<!--                    accept=".xlsx, .xls"-->
<!--                    :action="uploadUrl"-->
<!--                    :disabled="upload.isUploading"-->
<!--                    :headers="{ 'token': token }"-->
<!--                    :on-progress="handleFileUploadProgress"-->
<!--                    :on-success="handleFileSuccess"-->
<!--                    :on-error="handleFileError"-->
<!--                    :auto-upload="false"-->
<!--                    drag-->
<!--            >-->

<!--                &lt;!&ndash;                :action="upload.url + '?updateSupport=' + upload.updateSupport"&ndash;&gt;-->
<!--                <i class="el-icon-upload"></i>-->
<!--                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>-->
<!--                <div class="el-upload__tip text-center" slot="tip">-->
<!--                    &lt;!&ndash;                    <div class="el-upload__tip" slot="tip">&ndash;&gt;-->
<!--                    &lt;!&ndash;                        <el-checkbox v-model="upload.updateSupport" /> 是否更新已经存在的用户数据&ndash;&gt;-->
<!--                    &lt;!&ndash;                    </div>&ndash;&gt;-->
<!--                    <span>仅允许导入xls、xlsx格式文件。</span>-->
<!--                    <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;" @click="importTemplate">下载模板</el-link>-->
<!--                </div>-->
<!--            </el-upload>-->
<!--            <div slot="footer" class="dialog-footer">-->
<!--                <el-button type="primary" @click="submitFileForm">确 定</el-button>-->
<!--                <el-button @click="upload.open = false">取 消</el-button>-->
<!--            </div>-->
<!--        </el-dialog>-->
    </div>
</template>

<script>
    import moment from 'moment';
    import Treeselect from "@riophae/vue-treeselect";
    import "@riophae/vue-treeselect/dist/vue-treeselect.css";

    export default {
        name: "User",
        dicts: ['sys_normal_disable', 'sys_user_sex'],
        components: {
            Treeselect,
        },
        data() {
            return {
                token:window.sessionStorage.getItem('token'),
                uploadUrl:'http://127.0.0.1:8080/readExcel',
                // 遮罩层
                loading: true,
                // 选中数组
                ids: [],
                // 非单个禁用
                single: true,
                // 非多个禁用
                multiple: true,
                // 显示搜索条件
                showSearch: true,
                // 总条数
                total: 0,
                // 用户表格数据
                userList: [],
                // 弹出层标题
                title: "",
                // 部门树选项
                deptOptions: undefined,
                // 是否显示弹出层
                open: false,
                // 部门名称
                deptName: undefined,
                // 默认密码
                initPassword: undefined,
                // 日期范围
                dateRange: [],
                // 岗位选项
                // postOptions: [],
                // 角色选项
                roleOptions: [],
                schoolList: [],
                // 性别列表
                sexList:[
                    {
                        value:0,
                        label:"男",
                    },
                    {
                        value:1,
                        label:"女",
                    }
                ],
                // 表单参数
                form: {},
                defaultProps: {
                    children: 'subDept',
                    label: 'deptName',
                },
                // 用户导入参数
                upload: {
                    // 是否显示弹出层（用户导入）
                    open: false,
                    // 弹出层标题（用户导入）
                    title: "",
                    // 是否禁用上传
                    isUploading: false,
                    // 是否更新已经存在的用户数据
                    updateSupport: 0,
                },
                // 查询参数
                queryParams: {
                    pageNum: 1,
                    size: 10,
                    userName: null,
                    userPhone: null,
                    status: null,
                },
                // 表单校验
                rules: {
                    userName: [
                        { required: true, message: "用户名称不能为空", trigger: "blur" },
                        { min: 2, max: 12, message: '用户名称长度必须介于 2 和 12 之间', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: "用户密码不能为空", trigger: "blur" },
                        { min: 6, max: 32, message: '用户密码长度必须介于 5 和 32 之间', trigger: 'blur' }
                    ],
                    email: [
                        {
                            type: "email",
                            message: "请输入正确的邮箱地址",
                            trigger: ["blur", "change"]
                        }
                    ],
                    userPhone: [
                        { required: true, message: "用户手机号不能为空", trigger: "blur" },
                        {
                            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
                            message: "请输入正确的手机号码",
                            trigger: "blur"
                        }
                    ],
                }
            };
        },
        computed: {
            isCampusAgentForm() {
                return this.isCampusAgentRole(this.form && this.form.roleId);
            }
        },
        created() {
            // this.reset();
            // this.getDeptTree();
            // 岗位/角色/性别
            this.getRoleList();
            this.getSchoolList();
            this.getUserList();
        },
        methods: {
            async getUserList() {
                this.loading = true
                if(this.dateRange!=null) {
                    this.queryParams.beginTime=this.dateRange[0];
                    this.queryParams.endTime=this.dateRange[1];
                }
                const {data: res} = await this.$http.post('user/getSysUserList',this.queryParams)
                console.log(res)
                this.userList=res.data.children
                this.total=res.data.total
                // this.queryParams.pageNum=res.data.pageNum
                // this.queryParams.pageSize=res.data.pageSize
                this.loading=false
            },
            async getRoleList() {
                const {data: res} = await this.$http.get('role/getSysRoles');
                this.roleOptions=res.data;
            },
            async getSchoolList() {
                const {data: res} = await this.$http.get('school/getSchools');
                this.schoolList = res.data || [];
            },
            isCampusAgentRole(roleId) {
                const role = this.roleOptions.find(item => item.id === roleId);
                return !!(role && role.roleKey === 'campus_agent');
            },
            onRoleChange(roleId) {
                if (!this.isCampusAgentRole(roleId)) {
                    this.form.schoolId = null;
                }
            },
            // async getSexList() {
            //     const {data: res} = await this.$http.get('/dict/getDictDataByNeed?dictType=sys_user_sex')
            //     this.sexList = res.data.dataList
            // },
            /** 查询用户列表 */

            // 用户状态修改
            async handleStatusChange(row) {
                console.log(row)
                const {data: res} = await this.$http.get("user/changeUserStatus", {params: {
                        userId: row.id,
                        status:row.status,
                }})
                if(res.code==200){
                    if (row.status=="1"){
                        this.$message.success("用户已禁用！");
                    }else {
                        this.$message.success("用户已启用！");
                    }
                }else {
                    this.$message.error("操作失败，请联系工作人员！");
                }
            },
            // 取消按钮
            cancel() {
                this.open = false;
                this.reset();
            },
            // 表单重置
            reset() {
                this.form = {
                    id: 0,
                    roleId: "",
                    userName: null,
                    password: null,
                    userPhone: null,
                    email: null,
                    sex: "",
                    status: "0",
                    remark: null,
                    schoolId: null,
                };
            },
            /** 搜索按钮操作 */
            handleQuery() {
                // this.queryParams.pageNum = 1;
                this.getUserList();
            },
            /** 重置按钮操作 */
            resetQuery() {
                this.dateRange = [];
                // 查询参数
                this.queryParams= {
                        pageNum: 1,
                        size: 10,
                        userName: null,
                        userPhone: null,
                        status: null,
                },
                this.handleQuery();
            },
            // 多选框选中数据
            handleSelectionChange(selection) {
                this.ids = selection.map(item => item.id);
                this.single = selection.length != 1;
                this.multiple = !selection.length;
            },
            // 更多操作触发
            handleCommand(command, row) {
                switch (command) {
                    case "handleResetPwd":
                        this.handleResetPwd(row);
                        break;
                    // case "handleAuthRole":
                    //     this.handleAuthRole(row);
                    //     break;
                    default:
                        break;
                }
            },
            /** 新增按钮操作 */
            handleAdd() {
                this.reset();
                this.title = "添加用户"
                this.open = true;
            },
            /** 修改按钮操作 */
            async handleUpdate(row) {
                this.form = JSON.parse(JSON.stringify(row));
                this.title = "更新用户信息";
                this.open = true;
            },
            /** 重置密码按钮操作 */
            handleResetPwd(row) {
                this.$prompt('请输入"' + row.userName + '"的新密码', "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    closeOnClickModal: false,
                    inputPattern: /^.{6,20}$/,
                    inputErrorMessage: "用户密码长度必须介于 6 和 20 之间"
                }).then(({ value }) => {
                    this.$http.get("user/resetPassword",{params:{
                            userId:row.id,
                            password:value
                        }})
                    this.$message.success('密码重置成功！')
                }).catch(() => {
                    this.$message.info('取消重置！')
                });
            },
            /** 分配角色操作 */

            /** 提交按钮 */
            async submitForm() {
                this.$refs["form"].validate(valid => {
                    if (!valid) {
                        return;
                    }
                    if (this.isCampusAgentForm && !this.form.schoolId) {
                        this.$message.error('校园代理必须绑定学校');
                        return;
                    }
                    if (!this.isCampusAgentForm) {
                        this.form.schoolId = null;
                    }
                    if (this.form.id != 0) {
                        this.modifyFrom()
                    } else {
                        this.addFromFun();
                    }
                    this.open = false
                });
            },
            /**修改用户*/
            async modifyFrom() {
                const {data: res} = await this.$http.post('user/updateUser',this.form);
                if (res.code==200){
                    this.getUserList();
                    this.$message.success('修改成功')
                }else if(res.code==50003){
                    this.$message.error('用户手机号码已存在!')
                }else if(res.code==10005){
                    this.$message.error(res.msg || '校园代理必须绑定学校')
                }else {
                    this.$message.error('服务器异常')
                }
            },
            /**
             * 添加用户
             * */
            async addFromFun() {
                const {data: res} = await this.$http.post('user/insertUser', this.form);
                console.log(res)
                if(res.code==200){
                    this.$message.success('添加成功')
                    this.getUserList();
                }else if(res.code==50003){
                    this.$message.error('用户手机号码已存在!')
                }else if(res.code==10005){
                    this.$message.error(res.msg || '校园代理必须绑定学校')
                }else{
                    this.$message.error('服务器异常')
                }
            },
            /** 删除按钮操作 */
            async handleDelete(row) {
                this.$confirm('此操作将删除用户, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async ()=>{
                    if (row.id){
                        this.ids=[];
                        this.ids.push(row.id);
                    }
                    console.log(this.ids)
                    const {data: res} = await this.$http.post('user/delUser',this.ids);
                    console.log(res)
                    if (res.code==200){
                        this.getUserList();
                        this.$message.success('删除成功！')
                    }else if (res.code==20006){
                        this.$message.error('超级管理员不允许删除')
                    }else {
                        this.$message.error('服务器异常！')
                    }
                }).catch(() => {
                    this.$message.info('已取消删除！')
                })
            },
            /** 导出按钮操作 */
            handleExport() {
                this.$confirm(`确定要导出吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // 用户点击"确定"按钮，执行删除操作
                    this.$http.post('user/exportUser', this.ids, {
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        responseType: 'blob' // 指定响应类型为二进制流
                    }).then(res => {
                        // 获取响应数据并进行处理
                        const url = window.URL.createObjectURL(new Blob([res.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', '用户列表.xlsx'); // 设置下载文件名
                        document.body.appendChild(link);
                        link.click();
                    });
                }).catch(() => {
                    // 用户点击"取消"按钮，什么也不做
                })
            },
            /** 导入按钮操作 */
            handleImport() {
                this.upload.title = "用户导入";
                this.upload.open = true;
            },
            /** 下载模板操作 */
            importTemplate() {
                this.ids=[0]
                this.$http.post('/exportUser', this.ids, {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    responseType: 'blob' // 指定响应类型为二进制流
                }).then(res => {
                    // 获取响应数据并进行处理
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', '用户列表模板.xlsx'); // 设置下载文件名
                    document.body.appendChild(link);
                    link.click();
                });
            },
            // 文件上传中处理
            handleFileUploadProgress(event, file, fileList) {
                this.upload.isUploading = true;
            },
            // 文件上传成功处理
            handleFileSuccess(response, file, fileList) {
                this.upload.open = false;
                this.upload.isUploading = false;
                this.$refs.upload.clearFiles();
                if (response.code==200){
                    this.$message.error('用户['+response.data+']姓名、邮箱或电话不正确，请校正后重新导入！')
                    this.getUserList();
                }else if (response.code==50014){
                    this.$message.success('用户全部导入成功！')
                    this.getUserList();
                }else {
                    this.$message.error('用户导入失败！')
                }
            },
            //文件长传失败处理
            handleFileError(){
                this.$message.error('数据格式有误，请修正后重新上传！')
                this.upload.open = false;
            },
            // 提交上传文件
            submitFileForm() {
                this.$refs.upload.submit();
            },
            handleSizeChange(newSize) {
                this.queryParams.size = newSize;
                this.getUserList();
            }
            ,
            handleCurrentChange(current) {
                this.queryParams.pageNum = current;
                this.getUserList();
            },
        }
    };
</script>
